import { createContext } from "react";

export const VMSEMRUpdateURLContext = createContext<string | null>(null);
